import React from 'react';

// Professional icon system replacing emoji-based theming
// Based on Heroicons with custom task management icons

const createIcon = (d, viewBox = "0 0 24 24", isStroke = true) => ({ 
  size = 24, 
  className = '', 
  ...props 
}) => (
  <svg
    width={size}
    height={size}
    viewBox={viewBox}
    fill={isStroke ? "none" : "currentColor"}
    stroke={isStroke ? "currentColor" : "none"}
    strokeWidth={isStroke ? 2 : 0}
    strokeLinecap={isStroke ? "round" : undefined}
    strokeLinejoin={isStroke ? "round" : undefined}
    className={className}
    {...props}
  >
    <path d={d} />
  </svg>
);

// Task Complexity Icons (replacing 🌳🍄🌿)
export const TreeIcon = createIcon(
  "M12 2L13.09 8.26L22 9L17 14.74L18.18 22.5L12 19.77L5.82 22.5L7 14.74L2 9L10.91 8.26L12 2Z",
  "0 0 24 24",
  false // This is a fill icon
);

export const NetworkIcon = createIcon(
  "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z",
  "0 0 24 24",
  false // This is a fill icon
);

export const ConnectorIcon = createIcon(
  "M8 12h8m-8 0a4 4 0 01-4-4V7a4 4 0 118 0v1m0 4a4 4 0 104 4v-1a4 4 0 10-8 0v1"
);

// Status Icons
export const CheckCircleIcon = createIcon(
  "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
);

export const CheckIcon = createIcon(
  "M4.5 12.75l6 6 9-13.5"
);

export const ClockIcon = createIcon(
  "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
);

export const ExclamationCircleIcon = createIcon(
  "M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
);

export const InformationCircleIcon = createIcon(
  "M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
);

export const XMarkIcon = createIcon(
  "M6 18L18 6M6 6l12 12"
);

export const XCircleIcon = createIcon(
  "M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
);

// Action Icons
export const PlusIcon = createIcon(
  "M12 4.5v15m7.5-7.5h-15"
);

export const PencilIcon = createIcon(
  "M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
);

export const TrashIcon = createIcon(
  "M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
);

export const EyeIcon = createIcon(
  "M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z M15 12a3 3 0 11-6 0 3 3 0 016 0z"
);

export const ArrowRightIcon = createIcon(
  "M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
);

export const ArrowLeftIcon = createIcon(
  "M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
);

export const BackIcon = createIcon(
  "M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
);

export const EditIcon = createIcon(
  "M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
);

export const PlayIcon = createIcon(
  "M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
);

export const ChartBarIcon = createIcon(
  "M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z"
);

export const DocumentDuplicateIcon = createIcon(
  "M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"
);

export const ChevronRightIcon = createIcon(
  "M8.25 4.5l7.5 7.5-7.5 7.5"
);

export const ChevronDownIcon = createIcon(
  "M19.5 8.25l-7.5 7.5-7.5-7.5"
);

// Navigation Icons
export const HomeIcon = createIcon(
  "M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
);

export const FolderIcon = createIcon(
  "M2.25 12.75V12A2.25 2.25 0 014.5 9.75h15A2.25 2.25 0 0121.75 12v.75m-8.69-6.44l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25H11.69z"
);

export const DocumentIcon = createIcon(
  "M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
);

export const CogIcon = createIcon(
  "M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z M15 12a3 3 0 11-6 0 3 3 0 016 0z"
);

export const BookOpenIcon = createIcon(
  "M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18c-2.305 0-4.408.867-6 2.292m0-14.25v14.25"
);

export const RefreshIcon = createIcon(
  "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
);

export const ExternalLinkIcon = createIcon(
  "M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
);

export const CreditCardIcon = createIcon(
  "M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z"
);

// Utility function to get complexity icon
export const getComplexityIcon = (complexity) => {
  if (complexity >= 8) return TreeIcon; // High complexity - stable structure needed
  if (complexity >= 5) return NetworkIcon; // Medium complexity - interconnected
  return ConnectorIcon; // Low complexity - simple connections
};

// Status icon mapping
export const getStatusIcon = (status) => {
  switch (status) {
    case 'completed':
      return CheckCircleIcon;
    case 'in_progress':
    case 'processing':
      return ClockIcon;
    case 'failed':
    case 'error':
      return ExclamationCircleIcon;
    case 'rejected':
      return XCircleIcon;
    default:
      return InformationCircleIcon;
  }
};

// Export all icons for easy importing
export {
  // Keep individual exports for specific usage
};